const benchmarkedSteps= [
    {
      content: <h2>Let's begin !</h2>,
      locale: { skip: <strong>SKIP</strong> },
      placement: "center",
      target: "body"
    },
    {
      content: <h2>By clicking on the benchmarked cards, you can create a clone of the selected benchmarked survey.</h2>,
      placement: "bottom",
      target: "#benchmarkedCardBody",
      title: "First step"
    },
  ]
  export default benchmarkedSteps;